import { FlexiButton } from "@flexinet/ui-components";
import { MdReply } from "react-icons/md";

interface ReplyButtonProps {
    onClick: () => void;
}

export const ReplyButton = ({ onClick }: ReplyButtonProps) => {
    return (
        <FlexiButton variant={'outline'} leftSection={<MdReply />} onClick={onClick}>
            Reply
        </FlexiButton>
    );
};
